var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 842.65 346.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e97a24;fill-rule:evenodd;}.cls-2{font-size:218.44px;}.cls-2,.cls-3,.cls-4{fill:#fff;}.cls-2,.cls-3{font-family:CheltenhamItcTEE-Book, CheltenhamItcTEE;}.cls-3{font-size:243.27px;}.cls-4{font-size:54px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;letter-spacing:0.02em;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:0.02em;}.cls-7{letter-spacing:-0.05em;}.cls-8{letter-spacing:0.01em;}.cls-9{letter-spacing:0.02em;}.cls-10{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.4,0H276.61A69.6,69.6,0,0,1,346,69.4V276.61a69.6,69.6,0,0,1-69.4,69.4H69.4A69.6,69.6,0,0,1,0,276.61V69.4A69.6,69.6,0,0,1,69.4,0"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(68.68 245.86)"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(213.83 245.86)"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(376.51 237.89)"
  }, "w"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(554.7 237.89)"
  }, "is"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(720.89 237.89)"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(376.04 332.02)"
  }, "DIGI", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 125.06,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 156.76,
    y: 0
  }, "AL"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 231.71,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 261.2,
    y: 0
  }, "Y "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 313.95,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 376,
    y: 0
  }, "ISE")), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 381.67,
    y1: 260.65,
    x2: 841.67,
    y2: 260.65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.fef6144bdb0d2efe0a3e7bb2af6be7ae.svg";
export { ForwardRef as ReactComponent };